export default "__VITE_ASSET__D5fa5FEw__"